module.exports = __webpack_public_path__ + "media/CEMIMPCO WEB tut.2417742c.mp4";